import React from 'react'
import { Link } from 'react-router-dom'

type Props = {
  staticLinks?: boolean
}

const PrivacyContent = ({ staticLinks }: Props) => {
  const HomeLink = staticLinks ? (
    <a href='/'>← Back to home</a>
  ) : (
    <Link to='/'>← Back to home</Link>
  )

  const TermsLink = staticLinks ? (
    <a href='/terms'>Terms and conditions</a>
  ) : (
    <Link to='/terms'>Terms and conditions</Link>
  )

  return (
    <>
      <p className='faq-back'>{HomeLink}</p>
      <h1 className='faq-title'>Privacy policy</h1>
      <p className='faq-meta'>
        <strong>Effective date:</strong> 13 January 2024
      </p>

      <section className='faq-section'>
        <h2 className='faq-question'>Introduction</h2>
        <p className='faq-answer'>
          Thank you for using TinyInvoice.app (&quot;the Tool&quot;). This Privacy Policy explains how we collect, use, store, and share information when you use our services, particularly when you register using your Google account.
        </p>
      </section>

      <section className='faq-section'>
        <h2 className='faq-question'>Information we collect</h2>
        <p className='faq-answer'>
          When you register for TinyInvoice.app using your Google account, we collect the following information:
        </p>
        <ul className='faq-list'>
          <li><strong>Name:</strong> We use your name to personalize your profile on our tool.</li>
          <li><strong>Email:</strong> Your email is used for identification and communication purposes.</li>
        </ul>
      </section>

      <section className='faq-section'>
        <h2 className='faq-question'>How we use your information</h2>
        <p className='faq-answer'>
          We use the collected information solely to enhance your experience with TinyInvoice.app. Specifically, we use your name to personalize your profile, and your email for identification and communication.
        </p>
      </section>

      <section className='faq-section'>
        <h2 className='faq-question'>How we store your information</h2>
        <p className='faq-answer'>
          Your information is securely stored on our servers. We have implemented reasonable measures to protect the confidentiality and security of your personal data.
        </p>
      </section>

      <section className='faq-section'>
        <h2 className='faq-question'>How we share your information</h2>
        <p className='faq-answer'>
          We do not share your information with third parties. Your data is kept confidential and is used exclusively for the purposes outlined in this Privacy Policy.
        </p>
      </section>

      <section className='faq-section'>
        <h2 className='faq-question'>Google user data</h2>
        <p className='faq-answer'>
          TinyInvoice.app uses Google user data (name and email) only for the purposes stated in this Privacy Policy. We do not store or share any additional Google user data.
        </p>
      </section>

      <section className='faq-section'>
        <h2 className='faq-question'>Your choices</h2>
        <p className='faq-answer'>
          You can control the information you provide to TinyInvoice.app by managing your Google account privacy settings.
        </p>
      </section>

      <section className='faq-section'>
        <h2 className='faq-question'>Updates to this Privacy Policy</h2>
        <p className='faq-answer'>
          We may update this Privacy Policy to reflect changes in our practices or for other operational, legal, or regulatory reasons. We encourage you to review this Privacy Policy periodically.
        </p>
      </section>

      <section className='faq-section'>
        <h2 className='faq-question'>Contact us</h2>
        <p className='faq-answer'>
          If you have any questions or concerns about this Privacy Policy, please contact us at{' '}
          <a href='mailto:info@tinyinvoice.app'>info@tinyinvoice.app</a>.
        </p>
      </section>

      <section className='faq-section'>
        <p className='faq-answer'>
          By using TinyInvoice.app, you agree to the terms outlined in this Privacy Policy. See also our{' '}
          {TermsLink}.
        </p>
      </section>

      <p className='faq-back'>{HomeLink}</p>
    </>
  )
}

export default PrivacyContent
